export default [
	{
		header: '',
		children: [
			{
				title: 'หน้าแรก',
				type: 'ITEM',
				icon: 'mdi-home',
				to: '/'
			}
		]
	},
	{
		header: 'แอพพลิเคชั่น',
		children: [
			{
				title: 'ข่าวสาร',
				type: 'GROUP',
				icon: 'mdi-newspaper-variant-multiple',
				children: [
					{
						title: 'รายการ',
						to: '/news'
					},
					{
						title: 'เขียนข่าว',
						to: '/news/create'
					},
				]
			},
			{
				title: 'รับสมัครงาน',
				type: 'GROUP',
				icon: 'mdi-briefcase-outline',
				children: [
					{
						title: 'ประกาศรับสมัคร',
						to: '/job'
					}
				]
			},
			{
				title: 'เอกสาร',
				type: 'GROUP',
				icon: 'mdi-file-document-multiple-outline',
				children: [
					{
						title: 'รายการ',
						to: '/document'
					},
					{
						title: 'เพิ่ม',
						to: '/document/create'
					},
				]
			},
			{
				title: 'แบบฟอร์ม',
				type: 'GROUP',
				icon: 'mdi-form-select',
				children: [
					{
						title: 'รายการ',
						to: '/form'
					},
					{
						title: 'เพิ่ม',
						to: '/form/create'
					},
				]
			},
			{
				title: 'กิจกรรม',
				type: 'GROUP',
				icon: 'mdi-image-multiple',
				children: [
					{
						title: 'รายการ',
						to: '/activity'
					},
					{
						title: 'เพิ่ม',
						to: '/activity/create'
					},
				]
			},
			// {
			// 	title: 'KM',
			// 	type: 'GROUP',
			// 	icon: 'mdi-account-group-outline',
			// 	children: [
			// 		{
			// 			title: 'รายการ',
			// 			to: '/km'
			// 		},
			// 		{
			// 			title: 'เพิ่ม',
			// 			to: '/km/create'
			// 		},
			// 	]
			// },
			{
				title: 'ตำแหน่งทางวิชาการ',
				to: '/academic',
				type: 'ITEM',
				icon: 'mdi-account-tie'
			},
			{
				title: 'สไลด์',
				to: '/slide',
				type: 'ITEM',
				icon: 'mdi-image-move'
			},
			{
				title: 'ข้อมูลหน่วยงาน',
				to: '/about',
				type: 'ITEM',
				icon: 'mdi-information-outline'
			},
			{
				title: 'ถาม/ตอบ',
				to: '/faq',
				type: 'ITEM',
				icon: 'mdi-help'
			},
			{
				title: 'ปฏิทิน',
				to: '/calendar',
				type: 'ITEM',
				icon: 'mdi-calendar'
			},
			{
				title: 'KM',
				to: '/km',
				type: 'ITEM',
				icon: 'mdi-school'
			},
		]
	},
	{
		header: 'สถิติ',
		children: [
			{
				title: 'สถิติการเข้าใช้งาน',
				type: 'ITEM',
				icon: 'mdi-chart-areaspline',
				to: '/statistics'
			}
		]
	}
]